// src/components/AccessKeys.jsx

import React, { useState, useEffect } from "react";
import axios from "axios";
import CreateAccessKeyModal from "./modals/CreateAccessKeyModal";
import "./AccessKeys.css";

export default function AccessKeys() {
  const [keys, setKeys]           = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const API_BASE = import.meta.env.VITE_BACKEND_URL;
  const token    = localStorage.getItem("token");

  const fetchKeys = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${API_BASE}/api/access-keys`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setKeys(data);
    } catch (err) {
      console.error("Erro ao buscar access keys:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (keyData) => {
    try {
      // keyData pode estar vazio, pois MC gera internamente
      const { data } = await axios.post(
        `${API_BASE}/api/access-keys`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      // data.accessKey e data.secretKey vêm do MC
      alert(`Access Key: ${data.accessKey}\nSecret Key: ${data.secretKey}`);
      fetchKeys();
      setShowCreateModal(false);
    } catch (err) {
      console.error("Erro ao criar Access Key:", err);
      alert("Erro ao criar Access Key.");
    }
  };

  useEffect(() => {
    fetchKeys();
  }, []);

  return (
    <div className="container-page">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Access Keys</h2>
        <button
          className="btn btn-purple"
          onClick={() => setShowCreateModal(true)}
        >
          Nova Access Key
        </button>
      </div>

      {loading ? (
        <p>Carregando...</p>
      ) : (
        <div className="row gx-3 gy-3">
          {keys.map(k => (
            <div key={k.accessKey} className="col-sm-6 col-md-4">
              <div className="card p-3">
                <p><strong>{k.accessKey}</strong></p>
                <p>Status: {k.status}</p>
                <p>Policy: {k.policy}</p>
                <p>Nome: {k.name}</p>
                <p>Desc.: {k.description}</p>
                {/* aqui você pode adicionar botões Editar / Excluir */}
              </div>
            </div>
          ))}
        </div>
      )}

      {showCreateModal && (
        <CreateAccessKeyModal
          show={showCreateModal}
          onClose={() => setShowCreateModal(false)}
          onSubmit={handleCreate}
        />
      )}
    </div>
  );
}
